module.exports = __webpack_public_path__ + "img/banner.fa718923.jpg";